import { TrackedEventAction } from '@core/events/tracked-event-action.ts'

/**
 * Determines if the requested action requires page_url property within event's data object
 *
 * @internal
 */
export const isPageUrlRequiredAction = (action: TrackedEventAction) : boolean =>
    [
        TrackedEventAction.PROMPT_SHOWN,
        TrackedEventAction.PROMPT_ACCEPTED,
        TrackedEventAction.PROMPT_DISMISSED,
        TrackedEventAction.PROMPT_NOT_SHOWN,
        TrackedEventAction.PERMISSION_SHOWN,
        TrackedEventAction.PERMISSION_ACCEPTED,
        TrackedEventAction.PERMISSION_DISMISSED,
        TrackedEventAction.PERMISSION_DENIED,
        TrackedEventAction.PERMISSION_CHANGED,
        TrackedEventAction.SDK_IMPRESSION,
        TrackedEventAction.SDK_IMPRESSION_END,
    ].includes(action)